// CALL-750: a request made with `responseType: 'blob'` (e.g. template downloads) gets its ERROR body
// as a Blob too, so the axios interceptor can't read `error.response.data.message` and the user is
// left with the raw "Request failed with status code N". Read the blob back to recover the server
// message. Returns undefined when there's no parseable message so the caller can keep its fallback.
type BlobErrorLike = { response?: { data?: unknown } };

export const extractBlobErrorMessage = async (error: unknown): Promise<string | undefined> => {
    const data = (error as BlobErrorLike)?.response?.data;
    if (!(data instanceof Blob)) return undefined;
    try {
        const parsed = JSON.parse(await data.text());
        return typeof parsed?.message === 'string' ? parsed.message : undefined;
    } catch {
        return undefined;
    }
};

export const downloadBlobFile = ({
    data,
    fileName,
    contentType,
}: {
    data: BlobPart;
    fileName: string;
    contentType: string;
}) => {
    const blob = new Blob([data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};
